import React from 'react';

import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import { Button } from '@3plearning/react-components';
import moment from 'moment';
import StudentResultCell from './student-result-cell/student-result-cell';
import StudentResultTable from './student-result-table/student-result-table';
import { DISMISS_MODAL } from '../../../../containers/modal-manager/modal-manager-actions';

import Doughnuts from './doughnut-chart/doughnut-chart';
import {
  isDefined,
  STUDENT,
  getTruncatedName
} from '../../../../helpers/utils';

import {
  Footer,
  ResultsWrapper,
  AttemptsWrapper,
  DisplayResultsContainer,
  HighlightContainer,
  DisplayHighlightsContainer,
  ChartWrapper,
  IconWrapper,
  DisplayHighlights,
  ResultContainer
} from './student-result.styled';

import SvgIcon from '../../../svg-icon/svg-icon';

import {
  LastActivity,
  Highlights,
  Time,
  Info
} from '../../../../helpers/icon-dictionary';

const StudentResult = (props) => {
  const { i18n, chartData, studentReport } = props;
  const dispatch = useDispatch();

  const {
    lastResultDate,
    recentActivitiesTotalDuration: timeSpentOnActivities
  } = studentReport;

  const fullName = `${studentReport.studentFirstName} ${studentReport.studentLastName}`;

  /* eslint-disable indent */
  const lastResultDateText = isDefined(lastResultDate)
    ? moment(studentReport.lastResultDate).format('hh:mmA  - DD MMM YYYY')
    : i18n._(
        t('studentresultmodal.noCompletedActivities')`No completed activities`
      );
  /* eslint-enable indent */

  let timeSpentOnActivitiesText;

  if (timeSpentOnActivities) {
    const formatted = moment()
      .startOf('day')
      .seconds(timeSpentOnActivities)
      .format('H:mm:ss');
    const [hrs, mins, secs] = formatted.split(':');
    if (hrs !== '0') {
      timeSpentOnActivitiesText = `${hrs}h ${mins}m`;
    } else if (mins !== '00') {
      timeSpentOnActivitiesText = `${mins}m ${secs}s`;
    } else {
      timeSpentOnActivitiesText = `${secs}s`;
    }
  } else {
    timeSpentOnActivitiesText = i18n._(
      t('studentresultmodal.noTimeRecorded')`No time recorded`
    );
  }

  return (
    <ResultContainer>
      <ResultsWrapper>
        <ChartWrapper>
          <Doughnuts
            i18n={i18n}
            displayChartData={{
              resultType: STUDENT,
              studentName: fullName,
              truncatedName: getTruncatedName(fullName),
              studentPercent: studentReport.averageLastAttemptScore || 0,
              completedActivitiesCount:
                studentReport.completedCourseActivitiesCount || 0,
              totalActivitiesCount:
                studentReport.totalCourseActivitiesCount || 0,
              groupPercent: chartData.groupAverageScore || 0,
              groupActivitiesCount:
                chartData.groupCompletedActivitiesCount || 0,
              classroomPercent: chartData.classroomAverageScore || 0,
              classActivitiesCount:
                chartData.classroomCompletedActivitiesCount || 0
            }}
          />
        </ChartWrapper>
        <AttemptsWrapper>
          <DisplayResultsContainer>
            <StudentResultCell
              icon={Time}
              title={i18n._(
                t('studentresultmodal.timeOnActivities')`Time On Activities`
              )}
              value={timeSpentOnActivitiesText}
            />
            <StudentResultCell
              icon={LastActivity}
              title={i18n._(
                t(
                  'studentresultmodal.lastCompletedActivity'
                )`Last Completed Activity`
              )}
              value={lastResultDateText}
            />
          </DisplayResultsContainer>
          <DisplayHighlightsContainer>
            <DisplayHighlights>
              <IconWrapper>
                <SvgIcon icon={Highlights} />
              </IconWrapper>
              <div>
                {i18n._(t('studentresultmodal.highlights')`Highlights`)}
              </div>
            </DisplayHighlights>
            <DisplayResultsContainer data-testid="highlights">
              <HighlightContainer>
                <StudentResultTable
                  i18n={i18n}
                  data={studentReport}
                  quality="Weakness"
                  icon={Info}
                />
              </HighlightContainer>
              <HighlightContainer>
                <StudentResultTable
                  i18n={i18n}
                  data={studentReport}
                  quality="Strength"
                  icon={Info}
                />
              </HighlightContainer>
            </DisplayResultsContainer>
          </DisplayHighlightsContainer>
        </AttemptsWrapper>
      </ResultsWrapper>
      <Footer>
        <Button
          className="okButton"
          data-testid="ok-button"
          primary
          type={Button.LOZENGE}
          text={i18n._(t('studentresultmodal.okbutton')`OK`)}
          onClick={() => {
            dispatch({ type: DISMISS_MODAL });
          }}
        />
      </Footer>
    </ResultContainer>
  );
};

StudentResult.propTypes = {
  i18n: PropTypes.object,
  chartData: PropTypes.object,
  studentReport: PropTypes.object
};

export default StudentResult;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-result/student-result.js